import { type FC } from 'react';
import { Group, Pagination as MantinePagination, Select, Text } from '@mantine/core';
import { useUnit } from 'effector-react';
import { defaultPaginationPerPageOptions } from '../../constants';
import { type PaginationModel } from '../../lib/pagination';

interface PaginationProps {
    model: PaginationModel;
    total: number;
    usePerPage?: boolean;
}

export const Pagination: FC<PaginationProps> = ({ model, total, usePerPage = false }) => {
    const pagination = useUnit(model.$pagination);

    const handleChangePerPage = (perPage: string | null) => {
        if (!perPage) {
            return;
        }

        model.setPerPage(Number(perPage));
    };

    const handleChangeCurrentPage = (page: number) => {
        model.setPage(page - 1);
    };

    if (usePerPage) {
        return (
            <Group
                align='center'
                gap='sm'
                justify='space-between'
            >
                <Group
                    align='center'
                    gap='xs'
                >
                    <Text
                        size='xs'
                        fw={500}
                    >
                        Записей на странице
                    </Text>
                    <Select
                        maw={80}
                        value={pagination.perPage.toString()}
                        data={defaultPaginationPerPageOptions}
                        onChange={handleChangePerPage}
                    />
                </Group>

                <MantinePagination
                    total={total}
                    value={pagination.page + 1}
                    onChange={handleChangeCurrentPage}
                    size='sm'
                />
            </Group>
        );
    }

    return (
        <MantinePagination
            total={total}
            value={pagination.page + 1}
            onChange={handleChangeCurrentPage}
            size='sm'
        />
    );
};
